<mat-form-field class="flex-form">
  <mat-chip-grid #chipList id="{{id}}">
    @for (user of selectedUsers; track user) {
      <mat-chip (removed)="remove(user)">
        {{user?.fullName.replace(',', '')}}
        <mat-icon matChipRemove>cancel</mat-icon>
      </mat-chip>
    }
    <label>
      <input #userSearch (keyup.enter)="$event.preventDefault()"  id="{{id}}-input"
        [matAutocomplete]="autoAssignedToUser" [matChipInputFor]="chipList"
        [placeholder]="placeholder | async">

    </label>
    @if (!canListUsers) {
      <mat-error>
        {{'Can not list users.' | translate}}
      </mat-error>
    }
  </mat-chip-grid>
  <mat-autocomplete #autoAssignedToUser="matAutocomplete" (optionSelected)="onUserSelectedInternal($event)">
    @for (user of selectedUsersSub.asObservable() | async; track user) {
      <mat-option [value]="user">
        {{user.fullName.replace(',', '')}}
      </mat-option>
    }
  </mat-autocomplete>

</mat-form-field>
